<template>
  <BaseDialog centered ref="dialog" contentClass="notifications-dialog" @closeModal="close" @dialog-closed="close">
    <template slot="title">
      <NotificationsHeader class="notifications-dialog__header" :unread-count="unreadCount" @mark-all="markAllAsRead" />
    </template>
    <template slot="content">
      <NotificationEventList
        ref="list"
        class="notifications-dialog__body"
        :events="dialogEvents"
        :pending="dialogPending"
        :competitors="competitors"
        @open="onOpen"
        @mark-read="onMarkRead"
      />
      <div v-if="dialogTotalPages > 1" class="notifications-dialog__pagination">
        <TablePagination
          :value="dialogPage"
          :length="dialogTotalPages"
          :total-visible="isMobile ? 6 : 10"
          :disabled="dialogPending"
          @input="onInputPage"
        />
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseDialog from '@/components/base/BaseDialog.vue';
import NotificationEventList from '@/components/notifications-center/NotificationEventList.vue';
import NotificationsHeader from '@/components/notifications-center/NotificationsHeader.vue';
import TablePagination from '@/components/table/TablePagination.vue';
import isMobileMixin from '@/mixins/is-mobile-mixin';
import notificationOpenMixin from '@/mixins/notification-open-mixin';

export default {
  name: 'NotificationsDialog',
  components: {
    BaseDialog,
    NotificationEventList,
    NotificationsHeader,
    TablePagination,
  },
  mixins: [isMobileMixin, notificationOpenMixin],
  computed: {
    ...mapGetters('notifications', ['unreadCount', 'dialogEvents', 'dialogPending', 'dialogPage', 'dialogTotalPages']),
    ...mapGetters('biDashboard', ['competitors']),
  },
  watch: {
    $route() {
      this.close();
    },
  },
  mounted() {
    this.getDialogEvents({ page: 1 });
    // Fetch once per open — page changes reuse the same count.
    this.getEventsCount();
    this.$refs.dialog.openModal();
  },
  beforeDestroy() {
    this.resetDialogEvents();
  },
  methods: {
    ...mapActions('notifications', ['getDialogEvents', 'getEventsCount', 'resetDialogEvents', 'markAllAsRead']),
    onInputPage(page) {
      if (page === this.dialogPage) return;
      this.getDialogEvents({ page }).then(() => {
        this.$nextTick(() => {
          if (this.$refs.list && this.$refs.list.$el) {
            this.$refs.list.$el.scrollTop = 0;
          }
        });
      });
    },
    onMarkRead(notification) {
      this.markAsRead(notification.id);
    },
    onOpen(notification) {
      this.openNotification(notification);
      this.close();
    },
    close() {
      this.$emit('close-dialog');
    },
  },
};
</script>

<style lang="scss">
// Centered modal (BaseDialog defaults to a right-side drawer) — same recipe as
// .base-dialog__tender-view-dialog.
.base-dialog__notifications-dialog {
  position: relative;
  top: 0;
  height: auto;
  max-height: 85vh !important;
  width: 640px;
  max-width: 90vw;
  border-radius: $radius-xl;
  background: $color-white;

  .base-dialog__header {
    height: auto;
    padding: $space-md $space-md $space-sm;
  }

  .header__title {
    display: flex;
    margin: 0 !important;
    font-family: $font-family-body;
  }

  .header__close-icon {
    margin-right: 0 !important;
  }

  .base-dialog__header + .base-dialog__content {
    padding: 0 $space-md $space-md;
    background-color: $color-white;
    overflow: hidden;
  }
}

.notifications-dialog {
  &__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding-right: 16px;
  }

  &__pagination {
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    padding-top: $space-md;
  }
}
</style>
